// A resume/university row the researcher added but never picked an option for saves nothing, so
// the forms block Save until it is filled in or removed.
const COMPANY_SECTION = {label: 'company', idField: 'display_id'};
const UNIVERSITY_SECTION = {label: 'university', idField: 'university_id'};

const isBlank = (value) => value === null || value === undefined || value === '';

export const hasBlankSelection = (rows, idField) =>
    (rows || []).some((row) => !row._destroy && isBlank(row[idField]));

export const blankSelectionReason = (sections) => {
    const labels = sections
        .filter(({rows, idField}) => hasBlankSelection(rows, idField))
        .map(({label}) => label);

    if (labels.length === 0) return '';

    return `Select a ${labels.join(' and a ')} for every row, or remove the empty row`;
};

export const affinitySections = (companyRows, universityRows) => [
    {...COMPANY_SECTION, rows: companyRows},
    {...UNIVERSITY_SECTION, rows: universityRows},
];

export const hasBlankAffinitySelection = (companyRows, universityRows) =>
    !!blankSelectionReason(affinitySections(companyRows, universityRows));
